import get from 'lodash/get'

/** Reads LoopBack REST error shape from Axios errors. */
export function getApiErrorDetails(error: unknown): { message?: string; code?: string } {
  const message = get(error, 'response.data.error.message') as string | undefined
  const details = get(error, 'response.data.error.details') as { code?: string } | undefined
  const code = details && typeof details === 'object' && typeof details.code === 'string' ? details.code : undefined
  return { message, code }
}

/** Best-effort email from Google ID token (JWT) payload for UX only — not verified here. */
export function parseGoogleCredentialEmail(credential: string): string | undefined {
  try {
    const parts = credential.split('.')
    if (parts.length < 2) return undefined
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const pad = b64.length % 4
    if (pad) b64 += '='.repeat(4 - pad)
    const payload = JSON.parse(atob(b64)) as { email?: string }
    return typeof payload.email === 'string' ? payload.email : undefined
  } catch {
    return undefined
  }
}
